import { WarrantyObject } from "interfaces/warranty-interfaces";

const isBase64PdfValue = (value: string): boolean => {
  const trimmed = value.trim();
  return (
    trimmed.startsWith("data:application/pdf") ||
    trimmed.startsWith("data:application/octet-stream") ||
    trimmed.startsWith("data:")
  );
};

const isHttpPdfUrl = (value: string): boolean =>
  /^https?:\/\//i.test(value.trim());

export const extractPdfPathFromUrl = (url: string): string => {
  try {
    const pathname = new URL(url.trim()).pathname;
    const pdfIndex = pathname.indexOf("/pdf/");
    if (pdfIndex !== -1) {
      return pathname.slice(pdfIndex + 1);
    }
    const fileName = pathname.split("/").filter(Boolean).pop();
    return fileName ?? url.trim();
  } catch {
    return url.trim();
  }
};

/** New uploads (base64 data URL) are sent as-is; existing URLs become pdf paths. */
export const resolveWarrantyPdfForApi = (
  uploadedValue?: string,
  existingValue?: string
): string => {
  const uploaded = uploadedValue?.trim();
  if (uploaded) {
    if (isBase64PdfValue(uploaded)) {
      return uploaded;
    }
    if (isHttpPdfUrl(uploaded)) {
      return extractPdfPathFromUrl(uploaded);
    }
    return uploaded;
  }

  const existing = existingValue?.trim();
  if (!existing) {
    return "";
  }
  if (isHttpPdfUrl(existing)) {
    return extractPdfPathFromUrl(existing);
  }
  return existing;
};

export const hasExistingWarrantyPdfs = (
  warranty?: WarrantyObject | null
): boolean => {
  if (!warranty) {
    return false;
  }
  const hasStandard = Boolean(warranty.standardWarrantyPdf?.trim());
  const hasExtended = Boolean(warranty.extendedWarrantyPdf?.trim());
  return hasStandard || hasExtended;
};

export const buildModelCarName = (brand: string, model: string): string =>
  `${brand} ${model}`.trim();

export const findWarrantyByCarModel = (
  list: WarrantyObject[],
  carModel: string
): WarrantyObject | undefined =>
  list.find(
    (item) => item.carModel?.trim().toLowerCase() === carModel.trim().toLowerCase()
  );

export const findWarrantyByModelName = (
  list: WarrantyObject[],
  brand: string,
  model: string
): WarrantyObject | undefined => {
  const target = buildModelCarName(brand, model).toLowerCase();
  return list.find((item) => {
    const carModel = item.carModel?.trim().toLowerCase() ?? "";
    return carModel === target || carModel.endsWith(` ${model.toLowerCase()}`);
  });
};
